import type { StaticImageData } from 'next/image'

import { cn } from '@/utilities/ui'
import React from 'react'
import RichText from '@/components/RichText'

import type { MediaBlock as MediaBlockProps } from '@/payload-types'

import { Media } from '@/components/Media'

type Props = MediaBlockProps & {
  breakout?: boolean
  captionClassName?: string
  className?: string
  imgClassName?: string
  staticImage?: StaticImageData
  priority?: boolean
}

export function MediaBlock(props: Props) {
  const { captionClassName, className, imgClassName, media, staticImage, priority } = props

  let caption
  if (media && typeof media === 'object') caption = media.caption

  return (
    <div className={cn('relative', className)}>
      <div className="relative">
        {(media || staticImage) && (
          <Media
            priority={priority}
            imgClassName={cn('', imgClassName)}
            resource={media}
            src={staticImage}
          />
        )}
        {caption && (
          <div className={cn('relative pt-[10px] text-right', captionClassName)}>
            <RichText data={caption} enableProse={false} className="media-caption" />
          </div>
        )}
      </div>
    </div>
  )
}
